import React from 'react';

import { useAppDispatch, useAppSelector } from 'utils/hooks';

import Menu from 'components/shared/Menu';
import Switch from 'components/shared/Switch';

import ui from 'domains/ui';

function SettingsMenu() {
  const dispatch = useAppDispatch();
  const hideBranding = useAppSelector(ui.selectors.hideBranding);
  const showFilenames = useAppSelector(ui.selectors.showFilenames);
  const theme = useAppSelector(ui.selectors.theme);

  function handleToggleBranding() {
    dispatch(ui.actions.toggleHideBranding());
  }

  function handleToggleFilenames() {
    dispatch(ui.actions.toggleShowFilenames());
  }

  function handleToggleTheme() {
    dispatch(ui.actions.toggleTheme());
  }

  const menuItems = [
    <div className="settings-item">
      <div className="settings-title">Prices & Branding</div>
      <Switch
        active={!hideBranding}
        a11yLabel="prices and branding"
        onToggle={handleToggleBranding}
      />
    </div>,
    <div className="settings-item">
      <div className="settings-title">Filenames</div>
      <Switch a11yLabel="filenames" active={showFilenames} onToggle={handleToggleFilenames} />
    </div>,
    <div className="settings-item">
      <div className="settings-title">Light Theme</div>
      <Switch a11yLabel="theme" active={theme === 'light'} onToggle={handleToggleTheme} />
    </div>,
  ];

  return (
    <Menu
      menuItems={menuItems}
      className="settings-menu"
      triggerId="global-settings"
      triggerIcon="cog"
      triggerText="Open Settings Menu"
      iconOnlyTrigger
      appearance="light"
      direction="up"
      position="left"
    />
  );
}

export default SettingsMenu;
